
import { Map, View }
    from 'ol';
import OSM from 'ol/source/OSM';
import { transformExtent, fromLonLat }
    from 'ol/proj';
import WebGLPointsLayer from 'ol/layer/WebGLPoints';
import GeoJSON from 'ol/format/GeoJSON';
import { Vector as VectorSource } from 'ol/source';
import Overlay from 'ol/Overlay';
import Feature from 'ol/Feature';
import { Point, LineString, Polygon } from 'ol/geom';
import { DragPan, MouseWheelZoom, defaults } from 'ol/interaction';
import { platformModifierKeyOnly } from 'ol/events/condition';
import { Vector as VectorLayer, Tile as TileLayer } from 'ol/layer';
import { Style, Fill, Stroke } from 'ol/style';
import Icon from 'ol/style/Icon.js';


/*
var container = document.getElementById('popup');
var content = document.getElementById('popup-content');
var closer = document.getElementById('popup-closer');

var popupOverlay = new Overlay({
    element: container,
    autoPan: true,
    autoPanAnimation: {
        duration: 250
    }
});

if (closer) {
    closer.onclick = function () {
        popupOverlay.setPosition(undefined);
        closer.blur();
        return false;
    };
}

var pointsLayer;

var vectorSource = new Vector({
    features: [],
    attributions: '',
});

var features = [];
var featuresCategory = {
    all: 0,
};

$.getJSON(options.endpoint, function (data) {
    $.each(data.features, function (key, val) {
        // var coords = fromLonLat([val.geometry.coordinates[0], val.geometry.coordinates[1]]);
        featuresCategory[val.properties.category_id] = (featuresCategory[val.properties.category_id] ? featuresCategory[val.properties.category_id] : 0) + 1;
        featuresCategory['all']++;

        var feature = new Feature({
            id: val.properties.id,
            name: val.properties.name,
            content: val.properties.content,
            url: val.properties.url,
            category: val.properties.category,
            category_id: val.properties.category_id,
            shape: val.properties.category_id,
            thumbnail: val.properties.thumbnail,
            address: val.properties.address
        });

        if (val.geometry.type == "Point") {
            feature.setGeometry(new Point(val.geometry.coordinates))
        }

        if (val.geometry.type == "LineString") {
            feature.setGeometry(new LineString(val.geometry.coordinates))
        }

        if (val.geometry.type == "Polygon") {
            feature.setGeometry(new Polygon(val.geometry.coordinates))
        }

        features.push(feature);
    });

    vectorSource.addFeatures(features);
});

var style = {
    variables: {
        filterCategory: 'all'
    },
    filter: [
        'case',
        ['!=', ['var', 'filterCategory'], 'all'],
        ['==', ['get', 'category_id'], ['var', 'filterCategory']],
        true
    ],
    symbol: {
        symbolType: 'image',
        src: options.icons,
        size: [20, 30],
        rotateWithView: true,
        offset: [0, 9],
        textureCoord: [
            'match',
            ['get', 'category_id'],
            1,
            [0, 0.4, 0.25, 0.6],
            [0, 0.8, 0.25, 1]
        ]
    }
};


// pointsLayer = new WebGLPointsLayer({
//     source: vectorSource,
//     style: style
// });
pointsLayer = new VectorLayer({
    source: vectorSource,
    style: new Style({
        fill: new Fill({
            color: '#18244caa'
        }),
        stroke: new Stroke({
            color: '#18244caa',
            width: 2
        }),
    }),
});

var extent = transformExtent([13.552947, 49.011583, 24.928057, 55.491159], 'EPSG:4326', 'EPSG:3857');

if ($('#map-canvas').length) {
    var map = new Map({
        interactions: defaults({ dragPan: false, mouseWheelZoom: false }).extend([
            new DragPan({
                condition: function (event) {
                    //                return this.getPointerCount() === 2 || platformModifierKeyOnly(event);
                    return true;
                },
            }),
            new MouseWheelZoom({
                condition: platformModifierKeyOnly,
            })]),
        target: document.getElementById('map-canvas'),
        layers: [
            new TileLayer({
                source: new OSM()
            }),
            pointsLayer
        ],
        overlays: [popupOverlay],
        view: new View({
            projection: 'EPSG:3857',
            center: fromLonLat(options.center),
            zoom: 14,
            minZoom: 7,
            maxZoom: 16,
            extent: extent
        })
    });

    map.on('click', function (evt) {
        displayFeatureInfo(evt.pixel, evt.coordinate);
    });

    var displayFeatureInfo = function (pixel, coordinate) {
        var feature = map.forEachFeatureAtPixel(pixel, function (feature) {
            return feature;
        });

        if (feature) {
            $('#popup').removeClass('with-thumbnail');
            var feature_inner = '';

            if (feature.get('thumbnail')) {
                feature_inner += '<div class="row align-items-center gx-0"><div class="col-5"><div class="popup-thumbnail"><img src="' + feature.get('thumbnail') + '" /></div></div><div class="col-7">';
            }

            feature_inner += ''
                + '<h3 class="popup-title">' + feature.get('name') + '</h3>'
                + '<div class="popup-content">' + feature.get('content') + '</div>'
                + '<div class="popup-links">';

            if (feature.get('url')) {
                feature_inner += '<a class="button" href="' + feature.get('url') + '">Zobacz więcej</a>'
            }

            feature_inner += '<div class="clearfix"></div></div>';

            if (feature.get('thumbnail')) {
                feature_inner += "</div></div>";

                $('#popup').addClass('with-thumbnail');
            }

            content.innerHTML = feature_inner;

            //        var closeButton = document.getElementById('closeButton');
            //        closeButton.onclick = function () {
            //            popupOverlay.setPosition(undefined);
            //            closer.blur();
            //            return false;
            //        };

            var email = $('#popup .contact-email');
            $('#popup .contact-email').text(email.data('contact-1') + '@' + email.data('contact-2'));
            $('#popup .contact-email').attr('href', 'mailto: ' + email.data('contact-1') + '@' + email.data('contact-2'));

            popupOverlay.setPosition(coordinate);
        } else {
            popupOverlay.setPosition(undefined);

            closer.blur();
            return false;
        }
    };


}
$('#map-filter').on('click', 'a', function (event) {
    event.preventDefault();

    $('#map-filter a').removeClass('active');
    $(this).addClass('active');

    // if ($(this).attr('data-category-id') == "all") {
    //     style.variables.filterCategory = $(this).attr('data-category-id');
    // } else {
    //     style.variables.filterCategory = parseInt($(this).attr('data-category-id'));
    // }

    popupOverlay.setPosition(undefined);
    closer.blur();
    map.render();
});

*/

var extent = transformExtent([13.552947, 49.011583, 24.928057, 55.491159], 'EPSG:4326', 'EPSG:3857');


const source = new VectorSource({ wrapX: false });

const pointStyle = new Style({
    image: new Icon({
        anchor: [25, 60],
        scale: 0.75,
        anchorXUnits: 'pixels',
        anchorYUnits: 'pixels',
        src: options.icon,
    }),
});

if (options.feature) {
    var featureData = JSON.parse(options.feature);


    if (featureData.type == 'Point') {
        const feature = new Feature(new Point(featureData.coordinate));
        feature.setStyle(pointStyle);

        source.addFeature(feature);
    }
    if (featureData.type == 'LineString') {
        source.addFeature(new Feature(new LineString(featureData.coordinate)));
    }
    if (featureData.type == 'Polygon') {
        source.addFeature(new Feature(new Polygon(featureData.coordinate)));
    }
}


var pointsLayer;

pointsLayer = new VectorLayer({
    source: source
});


var map2 = new Map({
    interactions: defaults({ dragPan: false, mouseWheelZoom: false }).extend([
        new DragPan({
            condition: function (event) {
                //                return this.getPointerCount() === 2 || platformModifierKeyOnly(event);
                return true;
            },
        }),
        new MouseWheelZoom({
            condition: platformModifierKeyOnly,
        })]),
    target: document.getElementById('contact-map-ol'),
    layers: [
        new TileLayer({
            source: new OSM()
        }),
        pointsLayer
    ],
    // overlays: [popupOverlay],
    view: new View({
        projection: 'EPSG:3857',
        center: options.center,
        zoom: 14,
        minZoom: 7,
        // maxZoom: 16,
        // extent: extent
    })
});